import moment from "moment";

export const isValidDate = (dateString: string): boolean => {
  return !!dateString && moment(dateString).isValid();
};
